import {ConfEnv} from "../../../config/config";
import publicRequest from "../../../Infra/http/public.request";

export const getLiveGamesService = async () => {
  return publicRequest.get(
    `https://api-raeth4un-feed.sptpub.com/api/v1/promofeed/brand/${ConfEnv.API_BETBY.BRAND_ID}/en`
  );
};
